/**
 * Inyecta uno o varios bloques JSON-LD en el `<head>`.
 *
 * Van en el head y no en el cuerpo por dos razones: es donde los buscadores los
 * leen primero, y asi el marcado semantico de la pagina queda solo con
 * contenido de verdad, sin scripts colgando entre secciones.
 */
import { Helmet } from 'react-helmet-async';

import type { Esquema } from './esquemas';

export interface DatosEstructuradosProps {
  esquemas: Esquema[];
}

export function DatosEstructurados({ esquemas }: DatosEstructuradosProps) {
  if (esquemas.length === 0) return null;

  return (
    <Helmet>
      {esquemas.map((esquema, indice) => (
        <script key={indice} type="application/ld+json">
          {JSON.stringify(esquema)}
        </script>
      ))}
    </Helmet>
  );
}
